module.exports = __webpack_public_path__ + "img/LOGOSGPF256Prancheta 6.05f208f7.png";